import _default from './Dimmer';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/modules/Dimmer/index.js
// module id = 721
// module chunks = 0